import { useQuery } from '@tanstack/react-query';
import { useProfileStore } from 'src/features/stores/useProfileStore';
import { getAxios } from 'src/lib/axios';

const checkDemoModeForcedQuery = async (companyId: number): Promise<boolean> => {
  let url = `/api/ObtV2/CheckDemoModeForced/?`;
  url += '&companyId=' + companyId;
  return (await getAxios().get(url, {})).data;
};

export const useCheckDemoModeForcedQuery = () => {
  const profileStore = useProfileStore();
  const selectedUser = profileStore.users?.find((u) => u.ContactId === profileStore.selectedUserId);
  const companyId = selectedUser ? selectedUser.CompanyId : undefined;
  return useQuery({
    queryKey: ['checkDemoModeForcedQuery', companyId],
    queryFn: () => checkDemoModeForcedQuery(companyId!),
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: 'always',
    enabled: !!companyId
  });
};
